import { HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

export function createTranslateLoader(httpClient: HttpClient): TranslateLoader {
    return new TranslateHttpLoader(httpClient, "./assets/i18n/", ".json");
}

export const LocalizationSetting = TranslateModule.forRoot({
    loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [ HttpClient ]
    }
});